import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import { ACMEResponse } from '@b2c/types/core';
import { TODO } from '@b2c/types/index';
import angular, { IHttpService } from 'angular';
import { ValidateServiceModule } from '../validate/validate.service';

interface MultipleCouponsValidation {
  valid: boolean;
  invalidCouponCodes: [];
  validCouponcodes: Array<{
    eventPricepointMap: Record<string, string[]>;
    couponCode: string;
    valid: boolean;
    events: string[];
  }>;
  conflictingCoupons: [];
}

export class CouponsService {
  static $inject = ['$http', 'ApiVersionFactory', 'ValidateService'];

  api = {
    validateCoupon: (props: { tenantId: string; shoppingCartId: string; code: string }) => {
      return this.$http({
        method: 'get',
        headers: {
          'x-b2c-tenant-id': props.tenantId,
        },
        url: `/v2/b2c/carts/${props.shoppingCartId}/couponcode/${props.code}/validate`,
      });
    },

    validateMultipleCoupons: (props: { tenantId: string; shoppingCartId: string; couponCodes: string[] }) => {
      return this.$http<ACMEResponse<string>>({
        method: 'post',
        headers: {
          'x-b2c-tenant-id': props.tenantId,
        },
        url: `/v2/b2c/carts/couponcode/validate`,
        data: {
          shoppingCartId: props.shoppingCartId,
          couponCodes: props.couponCodes,
        },
      });
    },
  };

  valid = false;

  coupons: { code: string }[] = [];

  validCoupons: TODO[] = [];

  invalidCoupons: TODO[] = [];

  conflictingCoupons: TODO[] = [];

  events: Record<string, TODO> = {};

  memberships: TODO[] = [];

  errors: Record<string, { message: string }> | false = false;

  constructor(private $http: IHttpService, private ApiVersionFactory: TODO, private ValidateService: TODO) {}

  init() {
    this.reset();
    return true;
  }

  reset() {
    this.valid = false;
    this.coupons = [];
    this.validCoupons = [];
    this.invalidCoupons = [];
    this.events = {};
    this.memberships = [];
    this.errors = false;
  }

  getCoupons() {
    return this.coupons;
  }

  setCoupons(coupons) {
    let found;

    for (let i = 0, ii = coupons.length; i < ii; i++) {
      if (coupons[i]) {
        found = this.findCoupon(coupons[i]);
        if (!found) {
          this.addCoupon(coupons[i]);
        }
      }
    }
    return this.coupons;
  }

  hasCoupons() {
    return Array.isArray(this.coupons) && this.coupons.length;
  }

  setValid(valid) {
    this.valid = valid;
  }

  addCoupon(code) {
    const emptyCodes = this.coupons.filter((coupon) => coupon.code === '');
    let result: TODO | false = {
      code: code || '',
    };

    if (!emptyCodes.length) {
      this.coupons.push(result);
    } else {
      result = false;
    }

    return result;
  }

  /*
   *  {
   *  "valid": true,
   *  "invalidCouponCodes": [],
   *  "validCouponcodes": [{
   *    "eventPricepointMap": {
   *    "583600b922ae230c4aec47a1": ["53a879f130042d8e666ef9c6", "53a879ba30042d8e666ef9c5"]
   *  },
   *  "couponCode": "KCBUWINS",
   *  "valid": true,
   *  "events": ["583600b922ae230c4aec47a1", "583600b922ae230c4aec47a1"]
   *  }],
   *  "conflictingCoupons": []
   *  }
   */
  findEventTicketCoupon(eventId, ticketTypeId) {
    let eventIdMap;
    let result: TODO = false;

    for (let i = 0, ii = this.validCoupons.length; i < ii; i++) {
      if (eventId) {
        for (eventIdMap in this.validCoupons[i].eventPricepointMap) {
          if (this.validCoupons[i].eventPricepointMap.hasOwnProperty(eventIdMap) && eventIdMap === eventId) {
            result = {
              eventId: eventId,
              couponCode: this.validCoupons[i].couponCode,
            };

            if (ticketTypeId && this.validCoupons[i].eventPricepointMap[eventIdMap].indexOf(ticketTypeId) > -1) {
              result.ticketTypeId = ticketTypeId;
            }

            break;
          }
        }
      }
    }

    return result;
  }

  removeCoupon(index: number, code?: string) {
    let found;

    if (index !== null && index !== undefined) {
      if (this.coupons[index]) {
        this.coupons.splice(index, 1);
      }
    } else if (code) {
      found = this.findCoupon(code);
      if (found) {
        this.coupons.splice(found.index, 1);
      }
    }
  }

  findCoupon(code: string) {
    let result: TODO = false;

    for (let i = 0, ii = this.coupons.length; i < ii; i++) {
      if (this.coupons[i].code === code) {
        result = {
          index: i,
          coupon: this.coupons[i],
        };
      }
    }

    return result;
  }

  eventInCoupons(eventId) {
    let code;
    let r = false;

    for (code in this.events) {
      if (this.events.hasOwnProperty(code) && Array.isArray(this.events[code]) && this.events[code].length) {
        if (this.events[code].indexOf(eventId) > -1) {
          r = true;
        }
      }
    }

    return r;
  }

  validateCoupons(coupons) {
    let result: TODO = true;
    const validators: TODO[] = [];
    let couponCode;

    if (Array.isArray(coupons) && coupons.length) {
      for (let i = 0, ii = coupons.length; i < ii; i++) {
        couponCode = coupons[i];
        validators.push({
          field: 'form-coupon-' + i,
          coupon: {
            message: 'Invalid code',
            test: { code: couponCode },
          },
        });

        result = this.ValidateService.validate(validators);
      }
      if (result) {
        this.clearErrors();
      } else {
        this.errors = this.ValidateService.getErrorHash();
      }
    } else {
      this.clearErrors();
    }

    return result;
  }

  clearErrors() {
    this.errors = false;
  }

  process(data: MultipleCouponsValidation) {
    const coupons = data.validCouponcodes || [];
    const invalidCoupons = data.invalidCouponCodes || [];
    const conflictingCoupons = data.conflictingCoupons || [];
    const valid = data.valid;
    const events = {};
    let found;

    this.setValid(valid);
    for (let i = 0, ii = coupons.length; i < ii; i++) {
      found = this.findCoupon(coupons[i].couponCode);
      if (!found) {
        found = this.addCoupon(coupons[i].couponCode);
      }
      if (found) {
        events[coupons[i].couponCode] = Array.isArray(coupons[i].events) ? coupons[i].events : [];
      }
    }
    this.events = events;

    this.validCoupons = coupons;

    this.invalidCoupons = invalidCoupons;
    for (let i = 0, ii = this.invalidCoupons.length; i < ii; i++) {
      found = this.findCoupon(this.invalidCoupons[i]);
      if (found) {
        if (!this.errors) {
          this.errors = {};
        }
        this.errors['form-coupon-' + found.index] = {
          message: 'Invalid coupon',
        };
      }
    }

    this.conflictingCoupons = conflictingCoupons || [];

    for (let i = 0, ii = conflictingCoupons.length; i < ii; i++) {
      for (let j = 1, jj = this.conflictingCoupons[i].conflictingCouponCodes.length; j < jj; j++) {
        //first one is valid, the rest are invalid
        found = this.findCoupon(this.conflictingCoupons[i].conflictingCouponCodes[j]);
        if (found) {
          if (!this.errors) {
            this.errors = {};
          }
          this.errors['form-coupon-' + found.index] = {
            message: 'Coupon conflicts with: ' + this.conflictingCoupons[i].conflictingCouponCodes[0],
          };
        }
      }
    }
  }

  isInvalid(code) {
    const invalid = this.invalidCoupons.indexOf(code) > -1;
    let conflicting = false;

    for (let i = 0, ii = this.conflictingCoupons.length; i < ii; i++) {
      if (this.conflictingCoupons[i].conflictingCouponCodes.indexOf(code) > 0) {
        conflicting = true;
        break;
      }
    }
    return invalid || conflicting;
  }
}

export const CouponsServiceModule = angular
  .module('acme.common.service.coupons', [ApiVersionFactoryModule, ValidateServiceModule])
  .service('CouponsService', CouponsService).name;
